var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-tabs',_vm._l((_vm.items),function(item){return _c('v-tab',{key:item.title,attrs:{"to":item.path}},[_vm._v(_vm._s(item.title))])}),1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }